var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreamlineSharpColorTypewriterFlat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8fbffa",
    d: "M2.833 13.5L1 19v4h22v-4l-1.833-5.5H23v-2h-2.5L20 10h-5v2.5H9V10H4l-.5 1.5H1v2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002857",
    d: "M5.5 1h13v9H15v2.5H9V10H5.5zm0 17.5h3v-2h-3zm8 0h-3v-2h3zm2 0h3v-2h-3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineSharpColorTypewriterFlat);
export default __webpack_public_path__ + "static/media/streamline-sharp-color--typewriter-flat.2f1417c35589211d7cca947d0d244666.svg";
export { ForwardRef as ReactComponent };